module.exports = __webpack_public_path__ + "img/gaosu.5597dcc1.png";